import { ref, getDownloadURL } from "firebase/storage";
import Response from "../response";
import { errCodes } from "../response/errors";

class Documents {
  constructor(storage) {
    this.storage = storage;
  }

  async download(fileUrl) {
    try {
      const downloadURL = await getDownloadURL(ref(this.storage, fileUrl));

      // Fetch the file as a blob
      const response = await fetch(downloadURL);
      const blob = await response.blob();

      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = fileUrl.split('/').pop(); // Use the filename from the path
      
      // Append to document, click, and remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Clean up the object URL
      window.URL.revokeObjectURL(url);

      return Response.create({ downloadURL }, true);
    } catch (error) {
      console.error('Download error:', error);
      return Response.create({}, false, error, errCodes.Internal);
    }
  }
}

export default Documents;
